<template>
  <div class="RwvLogin">
    <div class="container page">
      <div class="row">
        <div class="col-md-6 offset-md-3 col-xs-12">
          <h1 class="text-xs-center">Login</h1>
          <!-- <p class="text-xs-center">
            <router-link :to="{ name: 'register' }">
              Need an account?
            </router-link>
          </p> -->
          <form v-on:submit.prevent="onSubmit(email, password);">
            <fieldset class="form-group">
              <input
                class="form-control form-control-lg"
                type="text"
                v-model="email"
                placeholder="Email"
              />
            </fieldset>
            <fieldset class="form-group">
              <input
                class="form-control form-control-lg"
                type="password"
                v-model="password"
                placeholder="Password"
              />
            </fieldset>
            <button class="btn btn-lg btn-primary pull-xs-right">
              Anmelden
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { LOGIN } from "@/store/actions.type";

export default {
  name: "RwvLogin",
  data() {
    return {
      email: null,
      password: null
    };
  },
  methods: {
    onSubmit(email, password) {
      console.log("on submit")
      var me = this;
      me.$store
        .dispatch(LOGIN, { email, password })
        .then(function() {
          console.log("logged in in login")
          me.$emit("loggedIn")
          me.$bvToast.toast("Sie sind nun eingeloggt", {
            title: "Erfolgreich angemeldet!",
            variant: 'success'
          })

          console.log("this.params.redirect")
          console.log(me.$route.query.redirect)
          if (me.$route.query.redirect) {
              me.$router.push({ path: me.$route.query.redirect });
          }
        })
    }
  },
  computed: {
    ...mapState({
      error: state => state.auth.error
    })
  },
  watch: {
    error(error) {
      console.log("in login - catch")
      console.log(error)
      this.$bvToast.toast(error.message, {
        title: error.name,
        variant: 'danger'
      })
    }
  }
};
</script>
